import React, { useCallback } from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  horizontalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Box, Flex, Text } from '@chakra-ui/react';
import FavoriteTile from './FavoriteTile';
import FavoritePlaceholderTile from './FavoritePlaceholderTile';
import { LAUNCHER } from './launcherVisualTokens';

const FavoriteSection = ({ ids, favoriteApps, onReorder, onNavigate, onRemove }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );

  const handleDragEnd = useCallback(
    (event) => {
      const { active, over } = event;
      if (over && active.id !== over.id) {
        onReorder(String(active.id), String(over.id));
      }
    },
    [onReorder],
  );

  const placeholders = Math.max(0, 4 - favoriteApps.length);

  return (
    <Box w="max-content" maxW="100%">
      {favoriteApps.length === 0 ? (
        <Text {...LAUNCHER.bodyMuted} py={1} mb={1}>
          Pick tools below to add to Favorites.
        </Text>
      ) : null}

      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <Flex
          w="max-content"
          maxW="100%"
          gap={2}
          align="stretch"
          flexWrap="nowrap"
          overflowX="visible"
          pb={0.5}
          mx={-0.5}
          px={0.5}
        >
          <SortableContext items={ids} strategy={horizontalListSortingStrategy}>
            <Flex gap={2} align="stretch" flex="0 0 auto">
              {favoriteApps.map((app) => (
                <FavoriteTile
                  key={app.id}
                  app={app}
                  onNavigate={onNavigate}
                  onRemove={onRemove}
                />
              ))}
            </Flex>
          </SortableContext>
          {Array.from({ length: placeholders }).map((_, i) => (
            <FavoritePlaceholderTile key={`ph-${i}`} />
          ))}
        </Flex>
      </DndContext>
    </Box>
  );
};

export default FavoriteSection;
